services.factory('API', [
    '$socket', '$q', '$timeout', '$http',
    'md5', 'config', 'constants', 'ErrorService',
    function API($socket, $q, $timeout, $http,
                 md5, config, Const, ErrorService) {
        var self = this,
            requests = {},
            eventNameRegExp = /\b(connect|disconnect|serverTime|loginToken|error|refreshClient|refreshSite)/,
            socketInstance = new $socket(config.socket.serverAddress, config.socket);
        var apiBaseUrl = config.socket.serverAddress.replace('wss', 'https') + '/http-api';

        function mockSocket(emit, data) {
            switch (emit) {

                case 'MT4GetClientSymbols':
                    return {
                        Code: "-1",
                        Description: "Err600"
                    };

                case 'MT4OpenPosition':
                    return {
                        Code: "-1",
                        Description: ""
                    }
            }
        }

        function createEmitMethod(event, cb) {
            return function socketGet(data) {
                //insert reqID to every request
                var reqId = setReqId(event, data),
                    _data = angular.extend({}, data || {}, {reqId: reqId}),
                    deferred = $q.defer(),
                    requestTimeout;

                function cancelRequest() {
                    socketInstance.off(event);
                    console.log('canceling request!', angular.copy(_data));
                    delete requests[reqId];
                    deferred.reject('cancelRequest');
                    throw new ErrorService({
                        source: 'API',
                        type: Const.error.type.VALIDATION,
                        severity: 'warning',
                        code: 'cancelRequest',
                        data: {request: angular.copy(_data)}
                    });
                }

                function requestResponse(response) {
                    socketInstance.off(event);
                    delete requests[reqId];

                    if (typeof response === 'string') {
                        response = angular.fromJson(response);
                    }

                    //cancel timeout on successful resolve
                    requestTimeout && $timeout.cancel(requestTimeout);
                    requestTimeout = null;

                    deferred.resolve(response);
                }

                //check if request is exists
                if (requests[reqId]) return $q.reject("[createEmitMethod] Request exists");

                socketInstance.emit(event, _data || {});

                //save current request
                requests[reqId] = deferred.promise;

                socketInstance.on(event, requestResponse);

                //cancel request on timeout
                requestTimeout = $timeout(cancelRequest, config.requestTimeout);

                return deferred.promise;
            }
        }

        function createMockEmitMethod(event, cb) {
            return function socketGet(data) {
                //insert reqID to every request
                var reqId = setReqId(event, data),
                    _data = angular.extend({}, data || {}, {reqID: reqId}),
                    deferred = $q.defer(),
                    requestTimeout;

                function cancelRequest() {
                    console.log('canceling request!', angular.copy(_data));
                    delete requests[reqId];
                    deferred.reject('cancelRequest');
                    throw new ErrorService({
                        source: 'mockAPI',
                        type: Const.error.type.VALIDATION,
                        severity: 'warning',
                        code: 'cancelRequest',
                        data: {request: _data}
                    });
                }

                function requestResponse(response) {
                    delete requests[reqId];

                    if (typeof response === 'string') {
                        response = angular.fromJson(response);
                    }

                    //cancel timeout on successful resolve
                    requestTimeout && $timeout.cancel(requestTimeout);
                    requestTimeout = null;

                    deferred.resolve(response);
                }

                //check if request is exists
                if (requests[reqId]) return $q.reject();

                $timeout(function () {
                    return requestResponse(mockSocket(event, _data || {}));
                }, 500);

                //save current request
                requests[reqId] = deferred.promise;

                //cancel request on timeout
                requestTimeout = $timeout(cancelRequest, config.requestTimeout);

                return deferred.promise;
            }
        }

        function setReqId(event, data) {
            return md5.createHash(event + JSON.stringify(data));
        }

        function handleConnect() {
            var deferred = $q.defer();
            log('socket is connecting...');

            if (socketInstance.getInstance().connected) {
                log('socket connected!');
                return deferred.resolve()
            }

            socketInstance.connect();

            socketInstance.on('connect', function () {
                console.log('socket connected!');
                return deferred.resolve();
            });

            return deferred.promise;
        }

        function removeAllSubscribers() {
            Object.keys(socketInstance.subscribers()).forEach(function (eventName) {
                if (!eventNameRegExp.test(eventName)) {
                    socketInstance.removeAllListeners(eventName);
                }
            });
        }

        function handleDisconnect() {
            console.log('socket is disconnecting...');
            socketInstance.disconnect();
        }


        function getToken(login, password) {
            var httpConfig = {
                method: 'GET',
                url: config.loginUrl,
                params: {
                    Login: login,
                    Password: password,
                    Source: Const.system.loginSources[0].id
                },
                timeout: 5000
            };
            return $http(httpConfig)
                .then(function (response) {
                    if (response.data.Code != "1") {
                        throw new ErrorService({
                            source: 'API',
                            type: Const.error.type.VALIDATION,
                            code: 'authFailed',
                            severity: 'warning',
                            data: {request: httpConfig.params, response: response.data}
                        });
                    }
                    return response.data;
                })
                .catch(function (err) {
                    //query failed of unknown reasons
                    if (err && typeof err === 'object' && err.status == '-1') {
                        throw new ErrorService({
                            source: 'API',
                            type: Const.error.type.NETWORK,
                            code: 'authTimeout',
                            data: {request: httpConfig.params}
                        })
                    }
                    //rethrow custom error
                    return $q.reject(err);
                })
        }

        socketInstance.on('disconnect', function () {
            console.log('socket disconnected!!!');
            requests = {};
            removeAllSubscribers();
        });


        function createRestMethod(event, method) {
            switch (method) {
                case 'Get':
                    return createRestMethodGet(event);
                case 'Post':
                case 'Put':
                case 'Delete':
                    throw new Error('not implemented!')
            }
        }

        function createRestMethodGet(event) {
            var headers = {
                'Content-Type': 'application/json'
            };

            return function (params, user) {
                if (user && user.token) {
                    headers.token = user.token;
                }
                console.log('api base url:::', apiBaseUrl);
                return $http({
                    method: 'GET',
                    url: apiBaseUrl + '/' + event,
                    headers: headers,
                    params: params
                })
            }
        }

        return {
            setup: function () {
                socketInstance = new $socket(config.socket.serverAddress, config.socket);
            },
            setSocketUrl: function (prefix) {
                var url = 'wss://' + prefix + '.pandats-client.io';
                socketInstance = new $socket(url, config.socket);
            },
            getSocket: function () {
                return socketInstance
            },
            connect: handleConnect,
            disconnect: handleDisconnect,
            login: createEmitMethod('login'),
            loginToken: createEmitMethod('loginToken'),
            loginDetails: createEmitMethod('loginDetails'),
            loginDetailsMT4: createEmitMethod('loginDetailsMT4Login'),
            loginTokenDetails: createEmitMethod('loginTokenDetails'),
            loginTokenDetailsMT4: createEmitMethod('loginTokenDetailsMT4Login'),
            quotesHistoryByTimeFrame: createEmitMethod('QuotesHistoryByTimeFrame'),
            mt4AccountSetPassword: createEmitMethod('MT4AccountSetPassword'),
            mt4LoginToken: createEmitMethod('MT4LoginToken'),
            mt4Login: createEmitMethod('MT4Login'),
            mt4Logout: createEmitMethod('MT4Logout'),
            mt4GetClientSymbols: createEmitMethod('MT4GetClientSymbols'),
            mt4GetAllSymbols: createEmitMethod('MT4GetAllSymbols'),
            MT4GetSymbolCategories: createEmitMethod('MT4GetSymbolCategories'),
            mt4GetSymbolsSnapshot: createEmitMethod('MT4GetSymbolsSnapshot'),
            mt4GetOpenPositions: createEmitMethod('MT4GetOpenPositions'),
            mt4GetClosedPositions: createEmitMethod('MT4GetClosedPositions'),
            mt4GetChart: createEmitMethod('MT4GetChart'),
            mt4GetChartHistory: createEmitMethod('MT4GetChartHistory'),
            mt4OpenPosition: createEmitMethod('MT4OpenPosition'),
            mt4ClosePosition: createEmitMethod('MT4ClosePosition'),
            mt4UpdatePosition: createEmitMethod('MT4UpdatePosition'),
            mt4DeletePosition: createEmitMethod('MT4DeletePosition'),
            mt4SwitchAccount: createEmitMethod('MT4AccountLogin'),
            getCustomerDetails: createEmitMethod('customerDetails'),
            logout: createEmitMethod('logout'),
            quotesSubscribe: createEmitMethod('quotesSubscribe'),
            quotesUnsubscribe: createEmitMethod('quotesUnsubscribe'),
            registration: createEmitMethod('registration'),
            personalDetails: createEmitMethod('updateCustomerDetailsRegistrationState'),
            updatePersonalDetails: createEmitMethod('updateCustomerDetails'),
            questionnaire: createEmitMethod('questionnaire'),
            mt4CreateAccount: createEmitMethod('MT4AccountCreate'),
            forgotPassword: createEmitMethod('forgotPassword'),
            changePassword: createEmitMethod('changePassword'),
            updateCustomer: createEmitMethod('updateCustomer'),
            transactionHistory: createEmitMethod('transactions'),
            //brand clientArea emits
            getCountries: createEmitMethod('countries'),
            getCurrencies: createEmitMethod('currencies'),
            creditCardDeposit: createEmitMethod('creditCardDeposit'),
            geo: createEmitMethod('ipInfo'),
            depositValue: createEmitMethod('depositValue'),
            demoDepositValues: createEmitMethod('demoDepositValues'),
            documents: createEmitMethod('documents'),
            document: createEmitMethod('document'),
            documentUpload: createEmitMethod('documentUpload'),
            documentDelete: createEmitMethod('documentDelete'),
            //new documents
            documentsGet: createEmitMethod('documentsGet'),
            documentSet: createEmitMethod('documentSet'),

            getTickets: createEmitMethod('tickets'),
            closeTicket: createEmitMethod('ticketClose'),
            createTicket: createEmitMethod('ticket'),
            transfer: createEmitMethod('transfer'),
            timezone: createEmitMethod('timezone'),
            promocode: createEmitMethod('promocode'),
            smsVerification: createEmitMethod('smsVerification'),
            smsVerificationPhone: createEmitMethod('smsVerificationPhone'),
            smsVerificationCode: createEmitMethod('smsVerificationCode'),
            location: createEmitMethod('location'),
            brandConfiguration: createEmitMethod('brandConfiguration'),
            wiretransfer: createEmitMethod('wiretransfer'),
            platform: createEmitMethod('platform'),
            bitcoinOrangepayDeposit: createEmitMethod('bitcoinOrangepayDeposit'),
            hostedPageDeposit: createEmitMethod('hostedPageDeposit'),
            qrcodeDeposit: createEmitMethod('qrcodeDeposit'),
            pendingDeposit: createEmitMethod('pendingDeposit'),
            initializeTransfer: createEmitMethod('initializeTransfer'),
            customerWithdrawalMethods: createRestMethod('withdrawalCustomerAccountMethods', 'Get'),
            getWithdrawalMethods: createEmitMethod('withdrawalMethods'),
            getLocalBanks: createEmitMethod('localBanks'),
            getWithdrawalReasons: createEmitMethod('withdrawalReasons'),
            withdrawal: createEmitMethod('withdrawalWireTransfer'),
            withdrawalLocalWireTransfer: createEmitMethod('withdrawalLocalWireTransfer'),
            withdrawalCreditCard: createEmitMethod('withdrawalCreditCard'),
            withdrawalSkrill: createEmitMethod('withdrawalSkrill'),
            withdrawalNeteller: createEmitMethod('withdrawalNeteller'),
            withdrawalFasaPay: createEmitMethod('withdrawalFasaPay'),
            withdrawalUnionPay: createEmitMethod('withdrawalUnionPay'),
            withdrawalCrypto: createEmitMethod('withdrawalCrypto'),
            withdrawalPapara: createEmitMethod('withdrawalPapara'),
            withdrawalMefete: createEmitMethod('withdrawalMefete'),
            withdrawalOther: createEmitMethod('withdrawalOther'),
            withdrawalCancel: createEmitMethod('withdrawalCancel'),
            withdrawalHistory: createEmitMethod('withdrawalRequests'),
            getPaymentMethods: createEmitMethod('depositMethods'),
            getFriendInvites: createEmitMethod('friendInvites'),
            getFriendInviteId: createEmitMethod('friendInviteId'),
            getOTP: createEmitMethod('getOTP'),
            setOTP: createEmitMethod('setOTP'),
            sendOTP: createEmitMethod('sendOTP'),
            questions: createEmitMethod('questions'),
            calcScoring: createEmitMethod('customerScore'),
            acceptRisk: createEmitMethod('riskApproval'),
            complianceStatus: createEmitMethod('complianceStatus'),
            acceptTnc: createEmitMethod('acceptTerms'),
            //sumsub
            initializeVerification: createEmitMethod('initializeVerification'),
            //thirdparty signup/auth
            registrationThirdParty: createEmitMethod('registrationThirdParty'),
            loginThirdParty: createEmitMethod('loginDetailsThirdParty'),
            //trading-central
            validateTCFeatures: createEmitMethod('tcValidate'),
            generateTCLink: createEmitMethod('tcGetURL'),
            //webtrader only login
            loginWebTrader: createEmitMethod('loginDetailsWebTrader'),
            loginTokenWebTrader: createEmitMethod('loginTokenMT4Login'),

            //social
            socialClientToken: createEmitMethod('socialClientToken'),
            socialRegister: createEmitMethod('socialRegister'),

            //email verification
            emailVerificationCode: createEmitMethod('emailVerificationCode'),
            emailVerificationCodeResend: createEmitMethod('emailVerificationCodeResend'),

            subscribe: function (event, handler) {
                socketInstance.on(event, handler);
            },
            unsubscribe: function (event) {
                socketInstance.off(event);
            },
            onConnect: function (cb) {
                console.log('onconnect');
                socketInstance.on('connect', cb);
            },
            onDisconnect: function (cb) {
                socketInstance.on('disconnect', cb);
            },
            onReconnect: function (cb) {
                socketInstance.on('reconnect', cb);
            },
            onReconnectAttempt: function (cb) {
                socketInstance.on('reconnect_attempt', function (attemptNumber) {
                    cb(attemptNumber)
                });
            },
            getToken: getToken
        }
    }
]);
